export default {
  payments: {
    payments: [],
    totalCount: null,
    limit: 2,
    totalPage: 1,
  },
};
